const baseEndpoint = '/configuration_profiles';

export const paths = {
  sessions: `${baseEndpoint}/sessions`,
  show: baseEndpoint,
  checkRegistration: `${baseEndpoint}/check_registration`,
};
